// Static mock data for MeetWithKTR concept prototype
import {
    Calendar,
    Megaphone,
    Lightbulb,
    PartyPopper,
    HeartHandshake,
    LineChart,
} from "lucide-react";

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "Services", to: "/#services", hasMega: true },
    { label: "Events", to: "/events" },
    { label: "Gallery", to: "/gallery" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
];

export const SERVICES = [
    {
        id: "request-meeting",
        icon: Calendar,
        title: "Request a Meeting",
        blurb: "Request an appointment to meet KTR.",
        to: "/request-meeting",
        chip: "01",
    },
    {
        id: "grievance",
        icon: Megaphone,
        title: "Submit a Grievance",
        blurb: "Raise public or community concerns.",
        to: "/grievance",
        chip: "02",
    },
    {
        id: "ideas",
        icon: Lightbulb,
        title: "Share Ideas",
        blurb: "Submit innovative ideas for Telangana.",
        to: "/share-ideas",
        chip: "03",
    },
    {
        id: "events",
        icon: PartyPopper,
        title: "Register for Events",
        blurb: "Register for town halls and public events.",
        to: "/events",
        chip: "04",
    },
    {
        id: "volunteer",
        icon: HeartHandshake,
        title: "Volunteer",
        blurb: "Become part of community initiatives.",
        to: "/volunteer",
        chip: "05",
    },
    {
        id: "track",
        icon: LineChart,
        title: "Track Request",
        blurb: "Track submitted requests using a Request ID.",
        to: "/track",
        chip: "06",
    },
];

export const STATS = [
    { label: "Meeting Requests", value: 4120, suffix: "" },
    { label: "Ideas Submitted", value: 2450, suffix: "" },
    { label: "Public Events", value: 82, suffix: "" },
    { label: "Active Volunteers", value: 1560, suffix: "" },
];

export const MANIFESTO = [
    {
        n: "01",
        title: "Easy Communication",
        body: "A single doorway for every citizen — no queues, no gatekeeping, no lost letters.",
    },
    {
        n: "02",
        title: "Transparent Tracking",
        body: "Every request travels through a numbered timeline you can watch move in daylight.",
    },
    {
        n: "03",
        title: "Citizen Participation",
        body: "Ideas from a village square weigh the same as those from a boardroom.",
    },
    {
        n: "04",
        title: "Simple Digital Experience",
        body: "Designed like the private sector, priced like a public good — friction removed.",
    },
];

export const EVENTS = [
    {
        id: "e1",
        title: "Hyderabad Town Hall",
        date: "March 12, 2026",
        location: "HITEX Exhibition Center, Hyderabad",
        image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1400&q=80",
        seats: 240,
    },
    {
        id: "e2",
        title: "Warangal Innovators Meet",
        date: "March 24, 2026",
        location: "Kakatiya Convention Hall, Warangal",
        image: "https://images.unsplash.com/photo-1560439514-4e9645039924?auto=format&fit=crop&w=1400&q=80",
        seats: 128,
    },
    {
        id: "e3",
        title: "Karimnagar Youth Assembly",
        date: "April 05, 2026",
        location: "SRR Government College, Karimnagar",
        image: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1400&q=80",
        seats: 310,
    },
];

export const INITIATIVES = [
    {
        id: "i1",
        tag: "Skilling",
        title: "Telangana Skill Corridor",
        body: "A district-wide skilling network pairing young graduates with real industry mentors.",
        image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "i2",
        tag: "Innovation",
        title: "Rural Digital Hubs",
        body: "Solar-powered pods bringing high-speed internet, payments and services to every mandal.",
        image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "i3",
        tag: "Community",
        title: "Neighbourhood Safety Grid",
        body: "Ward-level volunteer network reporting infrastructure gaps directly to a live dashboard.",
        image: "https://images.unsplash.com/photo-1520975916090-3105956dac38?auto=format&fit=crop&w=1200&q=80",
    },
];

export const GALLERY = [
    { src: "https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=900&q=80", h: 520 },
    { src: "https://images.unsplash.com/photo-1544928938-6852c1925194?auto=format&fit=crop&w=900&q=80", h: 380 },
    { src: "https://images.unsplash.com/photo-1560220604-1985ebfe28b1?auto=format&fit=crop&w=900&q=80", h: 460 },
    { src: "https://images.unsplash.com/photo-1626125345510-4603468eedfb?auto=format&fit=crop&w=900&q=80", h: 340 },
    { src: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=900&q=80", h: 500 },
    { src: "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=900&q=80", h: 400 },
    { src: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=900&q=80", h: 560 },
    { src: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80", h: 360 },
    { src: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=900&q=80", h: 480 },
];

export const UPDATES = [
    {
        id: "u1",
        tag: "Announcement",
        date: "Feb 04, 2026",
        title: "Town hall series returns to five new districts this spring",
        image: "https://images.unsplash.com/photo-1454923634634-bd1614719a7b?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "u2",
        tag: "Initiative",
        date: "Jan 28, 2026",
        title: "Rural Digital Hubs cross 500 mandals in operational rollout",
        image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "u3",
        tag: "Community",
        date: "Jan 22, 2026",
        title: "Youth Assembly programme opens applications for cohort 04",
        image: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "u4",
        tag: "Feature",
        date: "Jan 15, 2026",
        title: "How transparent tracking is rewriting citizen trust",
        image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "u5",
        tag: "Innovation",
        date: "Jan 09, 2026",
        title: "Innovators meet: 42 startups shortlisted from Warangal edition",
        image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "u6",
        tag: "Press",
        date: "Jan 02, 2026",
        title: "A new year, a new operating system for citizen requests",
        image: "https://images.unsplash.com/photo-1454923634634-bd1614719a7b?auto=format&fit=crop&w=1200&q=80",
    },
];

export const TESTIMONIALS = [
    {
        id: "t1",
        name: "Ananya R.",
        role: "Founder, Kaveri Textiles",
        image: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=400&q=80",
        quote:
            "I filed a request on a Tuesday. On Thursday I received a status update. On Monday, we met. This platform respected my time.",
    },
    {
        id: "t2",
        name: "Vikram S.",
        role: "Volunteer Coordinator, Karimnagar",
        image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=400&q=80",
        quote:
            "The tracking layer is what shifts everything. Neighbours who never used a government service before are on it every day.",
    },
    {
        id: "t3",
        name: "Meera D.",
        role: "Innovator, Hyderabad",
        image: "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?auto=format&fit=crop&w=400&q=80",
        quote:
            "It looks like a product, feels like a public service, and behaves like both. Rare to see in civic technology.",
    },
];

export const FAQS = [
    {
        q: "How do I request a meeting?",
        a: "Head to the Request Meeting page, fill in your details, purpose and preferred date. You will receive a request ID to track it end-to-end.",
    },
    {
        q: "How do I volunteer?",
        a: "Open the Volunteer page and tell us where you are and what you are good at. We match you with initiatives active in your district.",
    },
    {
        q: "How can I track my request?",
        a: "Use the Track Request page and paste your unique Request ID (e.g., MWK-2026-100234) to see a live timeline.",
    },
    {
        q: "Is this the official website of KTR?",
        a: "No. This is a design concept — a prototype exploring what a modern citizen engagement platform could feel like.",
    },
    {
        q: "Do I need an account?",
        a: "In this prototype, no. In a production deployment, a lightweight identity layer would be added for verified requests.",
    },
];

export const TIMELINE_STEPS = [
    { key: "submitted", label: "Submitted" },
    { key: "assigned", label: "Assigned" },
    { key: "review", label: "Under Review" },
    { key: "scheduled", label: "Meeting Scheduled" },
    { key: "completed", label: "Completed" },
];

export const MOCK_TRACK_RESULT = {
    requestId: "MWK-2026-100234",
    name: "Ananya R.",
    submittedOn: "Feb 04, 2026",
    currentStep: 2, // Under Review
    purpose: "Community skilling proposal — Kaveri Textiles",
    assignedTo: "District Grievance Cell, Hyderabad",
};

export const MARQUEE_WORDS = [
    "Citizen First",
    "Transparency",
    "Action",
    "Community",
    "Ideas",
    "Accountability",
    "Participation",
    "Progress",
];

export const DISTRICTS = [
    "Hyderabad",
    "Warangal",
    "Karimnagar",
    "Nizamabad",
    "Rangareddy",
    "Medak",
    "Khammam",
    "Nalgonda",
    "Adilabad",
    "Mahbubnagar",
];

export const CATEGORIES = {
    grievance: [
        "Roads & Infrastructure",
        "Water Supply",
        "Electricity",
        "Sanitation",
        "Public Safety",
        "Health",
        "Education",
        "Other",
    ],
    ideas: [
        "Technology",
        "Rural Development",
        "Education",
        "Environment",
        "Healthcare",
        "Governance",
        "Culture",
        "Other",
    ],
};
